var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advert6"},[_c('div',{staticClass:"advert6-content"},[_c('div',{staticClass:"advert6-close"},[_vm._v("×")])])])}]

export { render, staticRenderFns }